import './blog-article.component.scss'
import { throttle } from '../../application/utils/timings'

const article = document.querySelector('.blog-article')
const progress = document.querySelector('.blog-article-progress__line')

const scrollHandler = throttle(() => {
  const total = article.getBoundingClientRect().height
  const current = window.scrollY - article.offsetTop + window.innerHeight / 2
  let value = Math.round((current / total) * 100)
  if (value < 0) {
    value = 0
  }
  if (value > 100) {
    value = 100
  }
  progress.style.width = `${value}%`
}, 150)

if (article && progress) {
  window.addEventListener('scroll', scrollHandler)
}
